import React from 'react';
import StateSection from '~/src/components/CourtForms/StateSection';
import { DrillDownPanelLink } from '~/src/components/DrillDownPanel';
import { getDrillDownPanelLinkUrl, CourtFormLevel } from './helpers';
import PdfTableContainer from '~/src/containers/PdfTableContainer';
import { usesCountySubFilter } from '~/src/utils/additionalRegionForms';

interface RegionalCourtFormContentProps {
  level: CourtFormLevel;
  filterCategory: string;
  subFilterValue: string;
  itemsToRender: string[];
  childLabel: string;
  childLevel: CourtFormLevel;
  rootRouteUrl: string;
  region?: string;
}

const RegionalCourtFormContent: React.FC<RegionalCourtFormContentProps> = ({
  level,
  filterCategory,
  subFilterValue,
  itemsToRender,
  childLabel,
  childLevel,
  rootRouteUrl,
  region,
}) => {
  if (level === CourtFormLevel.FORMS) {
    const isCounty = usesCountySubFilter(region);
    return (
      <PdfTableContainer
        filterCategory={filterCategory}
        practiceArea={isCounty ? undefined : subFilterValue}
        locality={isCounty ? subFilterValue : undefined}
        region={region}
        disableBreadcrumb={true}
      />
    );
  }

  const itemList: React.ReactNode[] = [];
  itemsToRender.forEach((item: string) => {
    itemList.push(
      <StateSection key={`${item}_section`} stateName={item}>
        <DrillDownPanelLink
          key={`${item}_link`}
          label={childLabel ? `${item} ${childLabel}` : item}
          linkUrl={getDrillDownPanelLinkUrl({
            item,
            level,
            filterCategory,
            childLevel,
            rootRouteUrl,
          })}
        />
      </StateSection>,
    );
  });
  return <>{itemList}</>;
};

export default RegionalCourtFormContent;
